// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"b75134ed","453":"7a5c943b","934":"df1541f3"}[chunkId] + ".chunk.js";
};